/**
 * 全站路由配置
 *
 * 建议:
 * 1. 代码中路由统一使用name属性跳转(不使用path属性)
 */
import Vue from 'vue'
import Router from 'vue-router'
import {isURL} from '@/utils/validate'
import {checkLogin} from '@/utils/login'
import loginHttp from '@/utils/login'

Vue.use(Router)

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)

const skipLoadMenusRoutes = [
    {'name': 'demo', path: '/demo'}
]
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
    {path: '/404', component: _import('common/404'), name: '404', meta: {title: '404未找到'}},
    {path: '/error/:msg?', component: _import('common/error'), name: 'error', meta: {title: '系统错误'}},
    {path: '/login', component: _import('common/login'), name: 'login', meta: {title: '登录'}},
    {path: '/register/info', component: _import('common/registerMent/one'), name: 'register/info', meta: {title: '用户须知'}},
    {path: '/register', component: _import('common/register'), name: 'register', meta: {title: '注册章程'}},
    {path: '/forgetPassword', component: _import('common/forgetPassword'), name: 'forgetPassword', meta: {title: '找回密码'}},
    {path: '/companyList',component: _import('modules/gateway/companyList'),name:'companyList'},
    {path: '/companyDetail',component: _import('modules/gateway/companyDetail'),name:'companyDetail'},
    {path: '/questionDiscretion/detailLogin',component: _import('modules/questionDiscretion/detail-login'),name:'questionDiscretionDetail'},

]
// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
    path: '/',
    component: _import('main'),
    name: 'main',
    redirect: {name: 'home'},
    meta: {title: '主入口整体布局'},
    children: [
        // 通过meta对象设置路由展示方式
        // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
        // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
        // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
        // {path: '/home', component: _import('modules/mainDealManagement/index'), name: '主体信息管理', meta: {title: '主体信息管理', isTab: true}},
        // {path: '/theme', component: _import('common/theme'), name: 'theme', meta: {title: '主题'}},
        // {
        //     path: '/demo-echarts',
        //     component: _import('demo/echarts'),
        //     name: 'demo-echarts',
        //     meta: {title: 'demo-echarts', isTab: true}
        // },
        // {
        //     path: '/demo-echarts2',
        //     component: _import('demo/echarts2'),
        //     name: 'demo-echarts2',
        //     meta: {title: 'demo-ueditor2', isTab: true}
        // },
        {
            path: '/home',
            component: _import('common/home'),
            name:'home',
            meta: {title: '首页', isTab: true}
        },
        // 法人编辑页
        {
            path: '/mainDealManagement/index',
            component: _import('modules/mainDealManagement/index'),
            name: 'mainDealManagement/index',
            meta: {title: '主体信息管理', isTab: true}
        },
        // 法人详情页/管理员查看的详情页
        {
            path: '/mainDealManagementDetail/index',
            component: _import('modules/mainDealManagementDetail/index'),
            name: 'mainDealManagementDetail/index',
            meta: {title: '主体信息详情页', isTab: true}
        },
        // 法人变更页
        {
            path: '/mainDealManagementChange/index/:changeId/:id',
            component: _import('modules/mainDealManagementChange/index'),
            name: 'mainDealManagementChange/index',
            meta: {title: '法人主体信息变更管理编辑', isTab: true}
        },
        // 法人变更详情页
        {
            path: '/mainDealManagementChangeDetail/index/:changeId/:id',
            component: _import('modules/mainDealManagementChangeDetail/index'),
            name: 'mainDealManagementChangeDetail/index',
            meta: {title: '法人主体信息变更管理详情', isTab: true}
        },
        // 管理员首页
        {
            path: '/mainBodyInformationList/index',
            component: _import('modules/mainBodyInformationList/index'),
            name: 'mainBodyInformationList/index',
            meta: {title: '主体信息列表', isTab: true}
        },
        {
            path: '/digitalCertificateManagement/index',
            component: _import('modules/digitalCertificateManagement/index'),
            name: 'digitalCertificateManagement/index',
            meta: {title: '数字证书管理', isTab: true}
        },
        // 自然人编辑页/详情页
        {
            path: '/naturalBasicInformation/index',
            component: _import('modules/naturalBasicInformation/index'),
            name: 'naturalBasicInformation/natural-basicInfo-view',
            meta: {title: '自然人基本信息详情页', isTab: true}
        },
        // 自然人变更编辑页面
        {
            path: '/naturalBasicInformationChange/natural-basicInfo-form',
            component: _import('modules/naturalBasicInformationChange/natural-basicInfo-form'),
            name: 'naturalBasicInformationChange/natural-basicInfo-form',
            meta: {title: '自然人基本信息变更页', isTab: true}
        },
        // 自然人变更详情页面
        {
            path: '/naturalBasicInformationChangeDetail/natural-basicInfo-view',
            component: _import('modules/naturalBasicInformationChangeDetail/natural-basicInfo-view'),
            name: 'naturalBasicInformationChangeDetail/natural-basicInfo-view',
            meta: {title: '自然人基本信息变更详情页', isTab: true}
        },
        // 管理员查看的自然人详情页
        {
            path: '/naturalBasicInformationChange/natural-basicInfo-view',
            component: _import('modules/naturalBasicInformationChange/natural-basicInfo-view'),
            name: 'naturalBasicInformationChange/natural-basicInfo-view',
            meta: {title: '自然人基本信息变更详情页', isTab: true}
        },
        {
            path: '/changeHistory/change-list',
            component: _import('modules/changeHistory/change-list'),
            name: 'changeHistory/change-list',
            meta: {title: '主体信息变更历史', isTab: true}
        },
        {
            path: '/blacklist/blacklist-list',
            component: _import('modules/blacklist/blacklist-list'),
            name: 'blacklist/blacklist-list',
            meta: {title: '黑名单', isTab: true}
        },
        //问题描述列表
        {
            path: '/questionDiscretion/list',
            component: _import('modules/questionDiscretion/list'),
            name: 'questionDiscretion/list',
            meta: {title: '问题描述列表', isTab: true}
        },
        //问题描述编辑
        {
            path: '/questionDiscretion/exit/:id',
            component: _import('modules/questionDiscretion/exit'),
            name: 'questionDiscretion/exit',
            meta: {title: '问题描述编辑', isTab: true}
        },
        //问题描述详情
        {
            path: '/questionDiscretion/detail/:id',
            component: _import('modules/questionDiscretion/detail'),
            name: 'questionDiscretion/detail',
            meta: {title: '问题描述详情', isTab: true}
        },
        // 系统配置
        {
            path: '/systemConfiguration/systemConfiguration',
            component: _import('modules/systemConfiguration/systemConfiguration'),
            name: 'systemConfiguration/systemConfiguration',
            meta: {title: '系统配置', isTab: true}
        },
        // 主体名称修改列表
        {
            path: '/mainBodyUpdateNameList/mainBodyUpdateNameList',
            component: _import('modules/mainBodyUpdateNameList/mainBodyUpdateNameList'),
            name: 'mainBodyUpdateNameList/mainBodyUpdateNameList',
            meta: {title: '主体名称修改列表', isTab: true}
        },
    ],
    beforeEnter(to, from, next) {
        checkLogin(next)
    }
}

const router = new Router({
    mode: 'hash',
    // scrollBehavior: () => ({y: 0}),
    ssoLoginUrl: '',
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: globalRoutes.concat(mainRoutes)
})


/**
 * 动态加载菜单流程
 * 1、判断当前是否加载菜单
 * 2、如果未加载菜单，判断当前是否需要加载动态菜单
 * 3、出现在 globalRoutes 和 skipLoadMenusRoutes 中的路由不需要加载动态菜单。
 */
router.beforeEach((to, from, next) => {
    let currentRouteType = fnCurrentRouteType(to, globalRoutes)
    if (currentRouteType !== 'global') {
        currentRouteType = fnCurrentRouteType(to, skipLoadMenusRoutes)
    }
    if (router.options.isAddDynamicMenuRoutes || currentRouteType === 'global') {
        next()
    } else {
        initMenuList(function (result) {
            if (!result || result.code !== '1') {
                next()
            } else {
                next({...to, replace: true})
            }
        })
    }
})


/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * 判断逻辑：
 *    1、如果目标路由的name 或路径 出现在 globalRoutes 参数中
 * @param {*} route 当前路由
 * @param {*} globalRoutes 路由匹配数组
 */
function fnCurrentRouteType(route, globalRoutes = []) {
    var temp = []
    for (var i = 0; i < globalRoutes.length; i++) {
        if (route.path === globalRoutes[i].path || (route.name !== undefined && route.name === globalRoutes[i].name)) {
            return 'global'
        } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
            temp = temp.concat(globalRoutes[i].children)
        }
    }
    return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}


export function initMenuList(callback) {
    if (router.options.isAddDynamicMenuRoutes === true) {
        if (callback !== undefined) {
            callback()
        }
        return
    }
    loginHttp({
        url: '/sys/menu/nav',
        method: 'get',
    }).then(({data}) => {
        if (data && data.code === "1") {
            fnAddDynamicMenuRoutes(data.menuList)
            router.options.isAddDynamicMenuRoutes = true
            sessionStorage.setItem('menuList', JSON.stringify(data.menuList || '[]'))
            sessionStorage.setItem('permissions', JSON.stringify(data.permissions || '[]'))
        } else {
            sessionStorage.setItem('menuList', '[]')
            sessionStorage.setItem('permissions', '[]')
        }
        if (callback !== undefined) {
            callback(data)
        }
    }).catch((e) => {
        console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue')
        sessionStorage.setItem('menuList', '[]')
        sessionStorage.setItem('permissions', '[]')
        router.push({name: 'error'})
    })
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = []) {
    let routes = []
    fnAddDynamicMenuRoutesCicle(menuList, routes)
    mainRoutes.name = 'main-dynamic'
    mainRoutes.children = routes
    router.addRoutes([
        mainRoutes,
        {path: '*', redirect: {name: '404'}}
    ])
    // console.log(mainRoutes.children)
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
    // console.log('\n')
    // console.log('%c!<-------------------- 动态(菜单)路由 s -------------------->', 'color:blue')
    // console.log(mainRoutes.children)
    // console.log('%c!<-------------------- 动态(菜单)路由 e -------------------->', 'color:blue')
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutesCicle(menuList = [], routes = []) {
    var temp = []
    let funcList = []
    for (var i = 0; i < menuList.length; i++) {
        let menuItem = menuList[i]
        if (menuItem.list && menuItem.list.length >= 1) {
            temp = temp.concat(menuItem.list)
        } else if (menuItem.url && /\S/.test(menuItem.url)) {
            if (menuItem.funcList && menuItem.funcList.length >= 1) {
                funcList = funcList.concat(menuItem.funcList)
            }
            //有明确路由名称的表示静态路由
            if (menuItem.routeName) {
                continue
            }
            menuItem.url = menuItem.url.replace(/^\//, '')
            let url = menuItem.url
            let argIndex = url.indexOf('?')
            if (argIndex > 0) {
                url = url.substr(0, argIndex)
            }
            let routePath = url.replace('/', '-')
            var route = {
                path: routePath,
                component: null,
                name: routePath,
                meta: {
                    menuId: menuItem.menuId,
                    title: menuItem.name,
                    isDynamic: true,
                    isTab: true,
                    iframeUrl: ''
                }
            }
            // url以http[s]://开头, 通过iframe展示
            if (isURL(menuItem.url)) {
                route['path'] = `i-${menuItem.menuId}`
                route['name'] = `i-${menuItem.menuId}`
                route['meta']['iframeUrl'] = menuItem.url
            } else {
                try {
                    route['component'] = _import(`modules/${url}`) || null
                } catch (e) {
                }
            }
            routes.push(route)
        }
    }
    if (temp.length >= 1) {
        fnAddDynamicMenuRoutesCicle(temp, routes)
    }
    if (funcList.length >= 1) {
        fnAddDynamicMenuRoutesCicle(funcList, routes)
    }
}

export default router
